import React, { useEffect, useState } from "react";
import { Button, Steps } from "antd";
import { Provider } from "./MultiStepFormContext";
import Details from "./Details_v3";
import Review from "./Review";
import FamilyDetails from "./FamilyDetails_v3";
import EducationRecords from "./EducationRecords_v2";
import AssistanceRequirement from "./AssistanceRequirement_v2";
import References from "./References_v2";
import Documents from "./Documents";
import dayjs from "dayjs";
import moment from "moment";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import Success from "../Success/Success";
const { Step } = Steps;

const applicationIdInitial = null;

const detailsInitialState = {
  //---------------------------Personal Details------------------------------------------
  firstName: {
    value: "",
    required: true,
    label: "First Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  middleName: {
    value: "",
    required: true,
    label: "Middle Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  lastName: {
    value: "",
    required: true,
    label: "Last Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  dateOfBirth: {
    value: moment(),
    required: true,
    label: "Date Of Birth",
    type: "date",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  placeOfBirth: {
    value: "",
    required: true,
    label: "Place Of Birth",
    type: "custom",
    disabled: "false",
    col: 5,
    field_set: "Personal Details",
    visible: true,
  },
  identificationMark: {
    value: "",
    required: false,
    label: "Identification Mark",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  gender: {
    value: "",
    required: true,
    label: "Gender",
    type: "radio",
    disabled: "false",
    col: 5,
    field_set: "Personal Details",
    radio_item: ["Male", "Female", "Other"],
    visible: true,
  },
  religion: {
    value: "",
    required: true,
    label: "Religion",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },
  category: {
    value: "",
    required: true,
    label: "Category",
    type: "radio",
    disabled: "false",
    col: 7,
    field_set: "Personal Details",
    radio_item: ["General", "ST", "SC", "OBC", "Other"],
    visible: true,
  },
  physicalChallenges: {
    value: "",
    required: false,
    label: "Physical Challenges",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Personal Details",
    visible: true,
  },

  currentAddressLine1: {
    value: "",
    required: true,
    label: "Current Address Line1",
    copyTo: "permanentAddressLine1",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentAddressLine2: {
    value: "",
    required: false,
    label: "Current Address Line2",
    copyTo: "permanentAddressLine2",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentLandmark: {
    value: "",
    required: true,
    label: "Current Landmark",
    copyTo: "permanentLandmark",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentVillageArea: {
    value: "",
    required: true,
    label: "Current Village/Area/Locality",
    copyTo: "permanentVillageArea",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentBlockTaluka: {
    value: "",
    required: true,
    label: "Current Block/Taluka/Subdistrict",
    copyTo: "permanentBlockTaluka",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentDistrict: {
    value: "",
    required: true,
    label: "Current District",
    copyTo: "permanentDistrict",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentState: {
    value: "",
    required: true,
    label: "Current State",
    copyTo: "permanentState",
    type: "custom",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  currentPincode: {
    value: "",
    required: true,
    label: "Current PIN Code",
    copyTo: "permanentPincode",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },
  residingSince: {
    value: 0,
    required: true,
    label: "Residing Since (In years)",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Current Address",
    visible: true,
  },

  permanentAddressLine1: {
    value: "",
    required: true,
    label: "Permanent Address Line1",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentAddressLine2: {
    value: "",
    required: false,
    label: "Permanent Address Line2",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentLandmark: {
    value: "",
    required: true,
    label: "Permanent Landmark",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentVillageArea: {
    value: "",
    required: true,
    label: "Permanent Village/Area/Locality",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentBlockTaluka: {
    value: "",
    required: true,
    label: "PermanentBlock/Taluka/Subdistrict",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentDistrict: {
    value: "",
    required: true,
    label: "Permanent District",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentState: {
    value: "",
    required: true,
    label: "Permanent State",
    type: "custom",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },
  permanentPincode: {
    value: "",
    required: true,
    label: "Permanent PIN Code",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Permanent Address",
    visible: true,
  },

  currentContactPersonName: {
    value: "",
    required: true,
    label: "Contact Person Name",
    type: "text",
    copyTo: "permanentContactPersonName",
    disabled: "false",
    col: 3,
    field_set: "Current Contact Information",
    visible: true,
  },
  currentContactPersonRelationship: {
    value: "",
    required: true,
    label: "Contact Person Relationship",
    copyTo: "permanentContactPersonRelationship",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Contact Information",
    visible: true,
  },
  currentContactPersonLandline: {
    value: "",
    required: false,
    label: "Contact Person Landline",
    copyTo: "permanentContactPersonLandline",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Contact Information",
    visible: true,
  },
  currentContactPersonMobile: {
    value: "",
    required: true,
    label: "Contact Person Mobile",
    copyTo: "permanentContactPersonMobile",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Current Contact Information",
    visible: true,
  },
  currentContactPersonEmail: {
    value: "",
    required: false,
    label: "Contact Person Email",
    copyTo: "permanentContactPersonEmail",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Current Contact Information",
    visible: true,
  },

  permanentContactPersonName: {
    value: "",
    required: true,
    label: "Contact Person Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Contact Information",
    visible: true,
  },
  permanentContactPersonRelationship: {
    value: "",
    required: true,
    label: "Contact Person Relationship",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Contact Information",
    visible: true,
  },
  permanentContactPersonLandline: {
    value: "",
    required: false,
    label: "Contact Person Landline",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Contact Information",
    visible: true,
  },
  permanentContactPersonMobile: {
    value: "",
    required: true,
    label: "Contact Person Mobile",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Permanent Contact Information",
    visible: true,
  },
  permanentContactPersonEmail: {
    value: "",
    required: false,
    label: "Contact Person Email",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Permanent Contact Information",
    visible: true,
  },

  fatherName: {
    value: "",
    required: true,
    label: "Father Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  motherName: {
    value: "",
    required: true,
    label: "Mother Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  fatherMotherPhone: {
    value: "",
    required: true,
    label: "Father/Mother Phone",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  fatherMotherEmail: {
    value: "",
    required: true,
    label: "Father/Mother Email",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  fatherMotherPAN: {
    value: "",
    required: true,
    label: "Father/Mother PAN",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  domicileStateOfOrigin: {
    value: "",
    required: true,
    label: "State Of Origin",
    type: "custom",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  domicileState: {
    value: "",
    required: true,
    label: "Domicile State",
    type: "custom",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  domicileSince: {
    value: 0,
    required: true,
    label: "Domicile Since (in years)",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },
  nationality: {
    value: "",
    required: true,
    label: "Nationality",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Family Details",
    visible: true,
  },

  annualFamilyIncome: {
    value: 0,
    required: true,
    label: "Annual Family Income (INR)",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  houseNature: {
    value: "",
    required: true,
    label: "Nature of House: Rented/Owned/Other",
    type: "select",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  monthlyRent: {
    value: null,
    required: false,
    label: "If rented, what is monthly rent? (INR):",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: false,
  },
  houseType: {
    value: "",
    required: true,
    label: "Type of House: 1BHK/2BHK/3BHK/others",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  cultivableLand: {
    value: "",
    required: true,
    label: "Does the family possess any cultivable land? Yes/No. ",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  landAcres: {
    value: null,
    required: false,
    label: "If yes, how many acres?",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: false,
  },
  hasTV: {
    value: "",
    required: true,
    label: "Is TV available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  hasAC: {
    value: "",
    required: true,
    label: "Is AC available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  hasCar: {
    value: "",
    required: true,
    label: "Is Car available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  hasMotorcycleScooter: {
    value: "",
    required: true,
    label: "Is Motorcycle/scooter available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  hasWashingMachine: {
    value: "",
    required: true,
    label: "Is Washing Machine available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },
  hasComputerLaptop: {
    value: "",
    required: true,
    label: "Is Computer/Laptop available in your household?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Economical Details",
    visible: true,
  },

  // hobbiesInterests: "",
  // extraCurricularActivities: "",
  // hardship: "",
};

const EconomicalDetailsInitialState = {
  annualFamilyIncome: {
    value: "",
    required: true,
    label: "Annual Family Income (INR)",
    type: "number",
    disabled: "false",
    col: 3,
  },
  houseNature: {
    value: "",
    required: true,
    label: "Nature of House: Rented/Owned/Other",
    type: "text",
    disabled: "false",
    col: 3,
  },
  houseType: {
    value: "",
    required: true,
    label: "Type of House: 1BHK/2BHK/3BHK/others",
    type: "text",
    disabled: "false",
    col: 3,
  },
  monthlyRent: {
    value: "",
    required: true,
    label: "If rented, what is monthly rent? (INR):",
    type: "text",
    disabled: "false",
    col: 3,
  },
  cultivableLand: {
    value: "",
    required: true,
    label: "Does the family possess any cultivable land? Yes/No. ",
    type: "radio",
    radio_item: ["Yes", "No"],
    disabled: "false",
    col: 3,
  },
  landAcres: {
    value: "",
    required: true,
    label: "If yes, how many acres?",
    type: "text",
    disabled: "false",
    col: 3,
  },
  hasTV: {
    value: "",
    required: true,
    label: "Is TV available in your household?",
    type: "radio",
    disabled: "false",
    radio_item: ["Yes", "No"],
    col: 3,
  },
  hasAC: {
    value: "",
    required: true,
    label: "Is AC available in your household?",
    type: "radio",
    disabled: "false",
    radio_item: ["Yes", "No"],
    col: 3,
  },
  hasCar: {
    value: "",
    required: true,
    label: "Is Car available in your household?",
    type: "radio",
    disabled: "false",
    radio_item: ["Yes", "No"],
    col: 3,
  },
  hasMotorcycleScooter: {
    value: "",
    required: true,
    label: "Is Motorcycle/scooter available in your household?",
    type: "radio",
    radio_item: ["Yes", "No"],
    disabled: "false",
    col: 3,
  },
  hasWashingMachine: {
    value: "",
    required: true,
    label: "Is Washing Machine available in your household?",
    type: "radio",
    radio_item: ["Yes", "No"],
    disabled: "false",
    col: 3,
  },
  hasComputerLaptop: {
    value: "",
    required: true,
    label: "Is Computer/Laptop available in your household?",
    type: "radio",
    radio_item: ["Yes", "No"],
    disabled: "false",
    col: 3,
  },
};

const familyDetailsInitialState = {
  familyDetails: [
    {
      name: "",
      relationship: "",
      dateOfBirth: dayjs(),
      education: "",
      occupation: "",
      annualIncome: "",
      dependent: "",
    },
  ],
};

const educationRecordsInitialState = {
  educationRecords: [],
  educationAssistanceRequiredFor: "",
};

const assistanceRequirementInitialState = {
  courseName: {
    value: "",
    required: true,
    label: "Course Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  courseBranchStream: {
    value: "",
    required: true,
    label: "Stream Name",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  courseLevel: {
    value: "",
    required: true,
    label: "Course Level",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  enrollmentNumber: {
    value: "",
    required: true,
    label: "Enrolment / Application Number",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  collegeInstituteName: {
    value: "",
    required: true,
    label: "Name of college/institute",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  collegeInstituteStatus: {
    value: "Govt.College",
    required: true,
    label: "Status of Institute/College",
    type: "select",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    option_item: [
      { value: "Govt.College", label: "Govt.College" },
      { value: "Semi-Government", label: "Semi-Government" },
      { value: "Private", label: "Private" },
    ],
    visible: true,
  },
  courseDuration: {
    value: "",
    required: true,
    label: "Course duration/years",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  courseStartDate: {
    value: "",
    required: true,
    label: "Start Month/Year",
    type: "month_year",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  courseEndDate: {
    value: "",
    required: true,
    label: "Tentative End Month/Year",
    type: "month_year",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  currentYear: {
    value: "",
    required: true,
    label: "Current year of course",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  currentSemester: {
    value: "",
    required: true,
    label: "Current semester of course",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Basic Education Details",
    visible: true,
  },
  collegeAddressLine1: {
    value: "",
    required: true,
    label: "College Address line 1",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeAddressLine2: {
    value: "",
    required: false,
    label: "College Address line 2",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeLandmark: {
    value: "",
    required: true,
    label: "College Land Mark",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeVillageArea: {
    value: "",
    required: true,
    label: "College Village/Area/Locality",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeBlockTaluka: {
    value: "",
    required: true,
    label: "College Block/Taluka/Subdistrict",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeDistrict: {
    value: "",
    required: true,
    label: "College District",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeState: {
    value: "",
    required: true,
    label: "College State",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegePincode: {
    value: "",
    required: true,
    label: "College PIN Code",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },

  collegePhone: {
    value: "",
    required: true,
    label: "College Phone",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeEmail: {
    value: "",
    required: false,
    label: "College Email ID",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  collegeWebsite: {
    value: "",
    required: false,
    label: "College Website",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "College Address Details",
    visible: true,
  },
  tuitionFee: {
    value: "",
    required: true,
    label: "Tuition Fee",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  registrationFee: {
    value: "",
    required: false,
    label: "Registration Fee",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  examinationFee: {
    value: "",
    required: false,
    label: "Examination Fee",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  hostelFee: {
    value: "",
    required: false,
    label: "Hostel Fee",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  foodExpenses: {
    value: "",
    required: false,
    label: "Food Expenses",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  booksOtherEducationalMaterialExpenses: {
    value: "",
    required: false,
    label: "Books/Other educational materials expenses",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  otherExpenses1: {
    value: "",
    required: false,
    label: "Any Other-1, Pl. Specify",
    type: "text",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  otherExpenses2: {
    value: "",
    required: false,
    label: "Any Other-2, Pl. Specify",
    type: "text",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
  },
  totalFees: {
    value: "",
    required: true,
    label: "Total Fees (summation of all the fees)",
    type: "number",
    disabled: false,
    col: 3,
    field_set: "College Expense Details",
    visible: true,
    max_length: 500,
  },
  //Other fields
  fundingSource: {
    value: "",
    required: true,
    label: "Current planned source of fee without Education Assistance",
    type: "textArea",
    disabled: false,
    col: 6,
    field_set: "College Expense Details",
    visible: true,
    max_length: 500,
  },
  hasScholarship: {
    value: "",
    required: true,
    label:
      "Do you received OR applied OR eligible for any government scholarship, grants, or financial aid?",
    type: "radio",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    radio_item: ["Yes", "No"],
    visible: true,
  },
  scholarshipName: {
    value: "",
    required: false,
    label: "Name of scholarship",
    type: "text",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    visible: false,
  },
  scholarshipAmount: {
    value: 0,
    required: false,
    label: "Amount of Scholarship (INR)",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    visible: false,
  },
  assistanceAmount: {
    value: "",
    required: true,
    label: "Total Education Assistance Amount require per year (INR)",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    visible: true,
  },
  assistanceDuration: {
    value: "",
    required: true,
    label: "Number of year Education Assistance require",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    visible: true,
  },
  willingToRepay: {
    value: "",
    required: true,
    label:
      "Would you be willing to repay the Education Assistance amount once you secure a job,allowing the organization to provide assistance to other underprivileged children? (Y/N)",
    type: "radio",
    disabled: "false",
    col: 9,
    field_set: "Other Details",
    radio_item: ["Yes", "No"],
    visible: true,
  },
  repayPercentage: {
    value: 0,
    required: false,
    label:
      "If yes, what percentage of the Education Assistance amount would you be willing to repay?",
    type: "number",
    disabled: "false",
    col: 3,
    field_set: "Other Details",
    visible: false,
  },

  personalStatement: {
    value: "",
    required: true,
    label: "Please provide write up covering above topics/questions",
    type: "text",
    disabled: "false",
    col: 3,
    visible: true,
  },
  // applicationStatus: {
  //   value: "",
  //   required: false,
  //   label: "Application Status",
  //   type: "text",
  //   disabled: "true",
  //   col: 3,
  //   visible: true,
  // },
};

const referencesInitialState = {
  references: [
    {
      name: "",
      address: "",
      occupation: "",
      mobilePhone: "",
      officePhone: "",
      email: "",
    },
  ],
};

const documentsInitialState = {};

const renderStep = (step) => {
  switch (step) {
    case 0:
      return <Details />;
    case 1:
      return <FamilyDetails />;
    case 2:
      return <EducationRecords />;
    case 3:
      return <AssistanceRequirement />;
    case 4:
      return <References />;
    case 5:
      return <Documents />;
    case 6:
      return <Review />;
    default:
      return (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      );
  }
};

const MultiStepForm = () => {
  const { appId } = useParams();
  const [details, setDetails] = useState(detailsInitialState);
  const [familyDetails, setFamilyDetails] = useState(familyDetailsInitialState);
  const [educationRecords, setEducationRecords] = useState(
    educationRecordsInitialState
  );
  const [assistanceRequirement, setAssistanceRequirement] = useState(
    assistanceRequirementInitialState
  );
  const [references, setReferences] = useState(referencesInitialState);
  const [documents, setDocuments] = useState(documentsInitialState);
  const [economicalDetails, setEconomicalDetails] = useState(
    EconomicalDetailsInitialState
  );
  const userRole = sessionStorage.getItem("role");

  const [currentStep, setCurrentStep] = useState(
    userRole === "Student" ? 0 : 6
  );
  const [applicationId, setApplicationId] = useState(applicationIdInitial);
  const [visible, setVisible] = useState(false);
  const [stepDisabled, setStepDisable] = useState(false);
  const onChange = (value) => {
    setCurrentStep(value);
  };
  const next = () => {
    if (currentStep === 7) {
      setCurrentStep(0);
      setDetails(detailsInitialState);
      setFamilyDetails(familyDetailsInitialState);
      return;
    }
    setCurrentStep(currentStep + 1);
  };
  const prev = () => setCurrentStep(currentStep - 1);

  const navigate = useNavigate();

  useEffect(() => {
    setDetails(detailsInitialState);
    setDocuments(documentsInitialState);
    setReferences(referencesInitialState);
    setEconomicalDetails(EconomicalDetailsInitialState);
    setAssistanceRequirement(assistanceRequirementInitialState);
    setFamilyDetails(familyDetailsInitialState);

    const requestOptions = {
      data: sessionStorage.getItem("token"),
    };

    const getData = async () => {
      if (appId && userRole !== "Student") {
        const url = window.API_PREFIX + `forms/api/get/application/${appId}`;
        return await axios.get(url, requestOptions);
      } else {
        const url = window.API_PREFIX + "forms/api/get/all";
        return await axios.post(url, requestOptions);
      }
    };

    getData().then((res) => {
      if (res.data.status == 200) {
        ////////////////////////////////// setting details (step 1) form if it has been already filled by user //////////////////////////////////////////////////////////
        // if(application_data)
        var { application_data } = res.data;
        if (
          application_data["applicationStatus"] &&
          application_data["applicationStatus"] !== "pending" &&
          (application_data["applicationStatus"] !== "" ||
            application_data["applicationStatus"] !== null) &&
          userRole === "Student"
        ) {
          navigate("/Success");
        }
        // else if (userRole === "Student" && localStorage.getItem("")) {
        //   navigate("/verify");
        // }
        else if (userRole === "Admin") {
          navigate("/Admin/Dashboard/User_Approval");
        } else if (userRole === "Admin") {
          navigate("/Review");
        }
        if (Object.keys(application_data).length === 0) {
          setStepDisable(true);
        } else {
          sessionStorage.setItem("applicationId", application_data["id"]);
          setStepDisable(false);
        }
        var initial = detailsInitialState;
        let application_obj_keys = Object.keys(initial);
        for (var i = 0; i < application_obj_keys.length; i++) {
          if (Object.keys(application_data).includes(application_obj_keys[i])) {
            initial[application_obj_keys[i]]["value"] =
              application_data[application_obj_keys[i]];
          }
        }
        initial["dateOfBirth"]["value"] = dayjs(
          initial["dateOfBirth"]["value"]
        );
        setDetails(initial);
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////// setting family details (step 2) form if it has been already filled by user ////////////////////////////////////////////////
        var family_data = res.data.family_members_data;
        family_data = family_data.map((fd) => {
          fd["dateOfBirth"] = dayjs(fd["dateOfBirth"]);
          return fd;
        });
        setFamilyDetails({ familyDetails: family_data });
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////// setting Education Records (step 3) form if it has been already filled by user //////////////////////////////////////////////
        var education_data = res.data.education_records_data;
        setEducationRecords({ educationRecords: education_data });
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var { documents: docs } = res.data;
        const temp = {};
        for (let index = 0; index < docs.length; index++) {
          const res = docs[index];
          temp[res.documentType] = res.documentPath;
        }
        setDocuments(temp);
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////// setting Assistance Requirement (step 4) form if it has been already filled by user /////////////////////////////////////////
        var assistance_data = res.data.assistance_requirement_data;
        var initial_assistance = assistanceRequirementInitialState;
        let assistance_obj_keys = Object.keys(initial_assistance);
        for (var j = 0; j < assistance_obj_keys.length; j++) {
          if (Object.keys(assistance_data).includes(assistance_obj_keys[j])) {
            initial_assistance[assistance_obj_keys[j]]["value"] =
              assistance_data[assistance_obj_keys[j]];
          }
        }
        setAssistanceRequirement({
          ...initial_assistance,
          repayPercentage: {
            ...initial_assistance.repayPercentage,
            visible:
              initial_assistance.willingToRepay.value === true ? true : false,
          },
        });
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////// setting Reference (step 5) form if it has been already filled by user ////////////////////////////////////////////////
        var references_data = res.data.references_data;
        setReferences({ references: references_data });
        setVisible(true);
      } else if (res.data.status == 401) {
        sessionStorage.clear();
        window.location = "/Expired";
      }
    });
  }, [appId, userRole]);

  const handleBackButton = () => {
    navigate("/admin/verifier");
  };

  const [stepIsValid, setStepIsValid] = useState({
    personalDetails: "wait",
    familyDetails: "wait",
    educationRecords: "wait",
    educationAssistanceRequiredFor: "wait",
    references: "wait",
    documents: "wait",
  });

  return visible ? (
    <>
      <Provider
        value={{
          details,
          setDetails,
          setStepDisable,
          stepDisabled,
          next,
          prev,
          familyDetails,
          setFamilyDetails,
          educationRecords,
          setEducationRecords,
          assistanceRequirement,
          setAssistanceRequirement,
          references,
          setReferences,
          economicalDetails,
          setEconomicalDetails,
          applicationId,
          setApplicationId,
          documents,
          setDocuments,
          stepIsValid,
          setStepIsValid,
        }}
      >
        {userRole === "Student" ? (
          <Steps current={currentStep} onChange={onChange}>
            <Step
              title={"Personal Details"}
              // status={stepIsValid.personalDetails}
            />

            <Step
              title={"Family Details"}
              disabled={stepDisabled}
              // status={stepIsValid.familyDetails}
            />
            <Step
              title={"Education Records"}
              disabled={stepDisabled}
              // status={stepIsValid.educationRecords}
            />
            <Step
              title={"Education Assistance Requirement Details"}
              disabled={stepDisabled}
              // status={stepIsValid.educationAssistanceRequiredFor}
            />
            <Step
              title={"References"}
              disabled={stepDisabled}
              // status={stepIsValid.references}
            />
            <Step
              title={"Document Upload"}
              disabled={stepDisabled}
              // status={stepIsValid.documents}
            />
            <Step
              title={"Review and Save"}
              // disabled={
              //   !Object.values(stepIsValid).every((val) => val === true)
              // }
              // status={
              //   Object.values(stepIsValid).every((val) => val === true)
              //     ? "finish"
              //     : "wait"
              // }
            />
          </Steps>
        ) : (
          <div
            style={{
              display: "flex",
              margin: "1.25rem",
            }}
          >
            <Button onClick={handleBackButton}>Back</Button>
          </div>
        )}
        <main>{renderStep(currentStep)}</main>
      </Provider>
    </>
  ) : null;
};
export default MultiStepForm;
